module.exports = __webpack_public_path__ + "static/media/login-bg.53ad968c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-bg.jpg
// module id = 744
// module chunks = 0